import { render, staticRenderFns } from "./QuestionEscalation.vue?vue&type=template&id=88be3d46"
import script from "./QuestionEscalation.vue?vue&type=script&lang=ts"
export * from "./QuestionEscalation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports